import React from 'react';

export default function RadioToggleComp(props){
    return (
        <div className={`radio-toggle ${props.value ? 'on' : 'off'}`} onClick={props.onClick}>
            <div className='wrapper d-flex justify-content-between align-items-center'>
                <div className='circle' />
                <div className='state-label'>{props.value ? 'On' : 'Off'}</div>
            </div>
        </div>
    );
}
